/* Hjälptext */
import React from "react";
class Description extends React.Component {

    render() {
        return (
            <div>
                Lägg så många ord du kan med bokstäverna ovanför.
                Alla orden måste innehålla mittenbokstaven.
                Minst ett ord innehåller alla bokstäverna.
            </div>
        )
    }
}


export default Description;